export default "__VITE_ASSET__CZlIfaHA__"